import { FacebookMessengerShareButton } from 'react-share'

export default function FacebookMessengerShare({
  url,
  children,
}: {
  url: string
  children: React.ReactNode
}): JSX.Element {
  return (
    <FacebookMessengerShareButton
      className="share-icon"
      url={url}
      appId="808312863220061"
      style={{ width: '100%' }}
    >
      {children}
    </FacebookMessengerShareButton>
  )
}
